import React from 'react';

var key = {
    router: null,
    response: null,
    navigation: null
};
var _a = React.createContext(key), Provider = _a.Provider, Curious = _a.Consumer;

function Active (props) {
    return (React.createElement(Curious, null, function (_a) {
        var router = _a.router, response = _a.response;
        if (process.env.NODE_ENV !== "production") {
            if (!router.route.active) {
                throw new Error("You are attempting to use the \"active\" route interaction, but have not included it in your Curi router.\n\nimport curi from \"@curi/router\";\nimport active from \"@curi/route-active\";\n\nconst router = curi(history, routes, {\n  route: [active()]\n});");
            }
        }
        return props.children(router.route.active(props.name, response, props.params, props.partial), response);
    }));
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var BaseBlock = /** #__PURE__ */ (function (_super) {
    __extends(BaseBlock, _super);
    function BaseBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseBlock.prototype.on = function () {
        this.props.router.history.confirmWith(this.props.confirm);
    };
    BaseBlock.prototype.off = function () {
        this.props.router.history.removeConfirmation();
    };
    BaseBlock.prototype.componentDidMount = function () {
        if (this.props.active) {
            this.on();
        }
    };
    BaseBlock.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.active === prevProps.active &&
            this.props.confirm === prevProps.confirm) {
            return;
        }
        this.off();
        if (this.props.active) {
            this.on();
        }
    };
    BaseBlock.prototype.componentWillUnmount = function () {
        this.off();
    };
    BaseBlock.prototype.render = function () {
        return null;
    };
    BaseBlock.defaultProps = {
        active: true
    };
    return BaseBlock;
}(React.Component));
function Block(props) {
    return (React.createElement(Curious, null, function (_a) {
        var router = _a.router;
        return React.createElement(BaseBlock, __assign({}, props, { router: router }));
    }));
}

function curiProvider(router) {
    return /** #__PURE__ */ (function (_super) {
        __extends(Router, _super);
        function Router(props) {
            var _this = _super.call(this, props) || this;
            _this.state = {
                emitted: __assign({}, router.current(), { router: router })
            };
            return _this;
        }
        Router.prototype.componentDidMount = function () {
            this.setupRespond(router);
        };
        Router.prototype.setupRespond = function (router) {
            var _this = this;
            this.stopResponding = router.observe(function (emitted) {
                if (!_this.removed) {
                    _this.setState({ emitted: emitted });
                }
            }, { initial: false });
        };
        Router.prototype.componentWillUnmount = function () {
            this.removed = true;
            /* istanbul ignore else */
            if (this.stopResponding) {
                this.stopResponding();
            }
        };
        Router.prototype.render = function () {
            var children = this.props.children;
            return (React.createElement(Provider, { value: this.state.emitted }, children(this.state.emitted)));
        };
        return Router;
    }(React.Component));
}

var BaseNavigating = /** #__PURE__ */ (function (_super) {
    __extends(BaseNavigating, _super);
    function BaseNavigating(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            cancelFn: undefined
        };
        return _this;
    }
    BaseNavigating.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return (nextState.cancelFn !== this.state.cancelFn ||
            nextProps.children === this.props.children);
    };
    BaseNavigating.prototype.render = function () {
        var cancelFn = this.state.cancelFn;
        return this.props.children(cancelFn);
    };
    BaseNavigating.prototype.componentDidMount = function () {
        var _this = this;
        this.stopCancelling = this.props.router.cancel(function (cancelFn) {
            if (!_this.removed) {
                _this.setState({
                    cancelFn: cancelFn
                });
            }
        });
    };
    BaseNavigating.prototype.componentWillUnmount = function () {
        this.removed = true;
        if (this.stopCancelling) {
            this.stopCancelling();
        }
    };
    return BaseNavigating;
}(React.Component));
function Navigating(props) {
    return (React.createElement(Curious, null, function (_a) {
        var router = _a.router;
        return React.createElement(BaseNavigating, __assign({}, props, { router: router }));
    }));
}

export { Active, Block, curiProvider, Curious, Navigating };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@curi/react-universal/dist/curi-react-universal.es.js
// module id = 149
// module chunks = 0